webpackJsonp([2],{

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuemSomos_vue__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuemSomos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuemSomos_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuemSomos_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuemSomos_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c670c8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuemSomos_vue__ = __webpack_require__(716);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuemSomos_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c670c8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuemSomos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 697:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-w"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_vm._v("Página Principal")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"breadcrumb-item"},[_c('span',[_vm._v("Quem Somos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element-wrapper pb-2"},[_c('h3',[_vm._v("Quem Somos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element-box"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col text-right"},[_c('h4',[_vm._v("Como o Dr. Achei surgiu")]),_vm._v(" "),_c('p',[_vm._v("Indignados com os preços abusivos, a falta de informação para ter acesso a saúde, a assistência gratuita precária, a plataforma tecnológica “Dr. Achei” foi criada para atender e ajudar milhares de brasileiros a terem acesso de maneira rápida e eficiente à soluções relacionadas a Área da Saúde.\n              Através de nossa solução de Payment Platform as a Service, o Dr Achei é uma startup de pagamentos na qual possibilita buscar médicos, laboratórios, consultórios entre diversos outros serviços.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":__webpack_require__(717),"alt":""}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-4"},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":__webpack_require__(687),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h4',[_vm._v("Como Funciona")]),_vm._v(" "),_c('p',[_vm._v("Com o Dr. Achei você escolhe o profissional ou local que deseja ser atendido, realiza orçamento dos seus exames, agenda suas consultas médicas, odontológicas e exames laboratoriais e de imagem, solicita consulta domiciliar ou coleta domiciliar para sua comodidade e realiza o pagamento de maneira simples e fácil através da nossa plataforma.")]),_vm._v(" "),_c('p',[_vm._v("Disponibilizamos diversas ferramentas inovadoras, oferecendo acesso a informação como currículo e avaliação dos profissionais, cadastro de prontuários médicos a qualquer tempo após o cadastro, compra de consultas e exames, atendimento delivery dentre outras.")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col text-right"},[_c('h4',[_vm._v("Visão")]),_vm._v(" "),_c('p',[_vm._v("Ser a maior STARTUP DO PAÍS NA ÁREA DA SAÚDE oferecerendo em um só lugar serviços relacionados a saúde e bem-estar, trazendo comodidade e segurança!")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":__webpack_require__(688),"alt":""}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.c570171.jpg";

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.9812a1f085bd74f47ff7.js